import { useContext } from "react";

import { UserContext } from "./userContext";

export const useUserContext = () => {
  const context = useContext(UserContext);
  if (context === undefined || context === null) {
    throw new Error("useUserContext must be used within a UserProvider");
  }
  return context;
};
